import { getConfig, getInterceptors } from '@goparrot-dashboard-api/shared';
import { VendorExternalMerchantFacade, VendorFacade } from '@goparrot/vendor-sdk';

const BASE_PATH = 'api/v2/vendor';
export const vendorFacade = new VendorFacade(getConfig(BASE_PATH), getInterceptors());
export const vendorExternalMerchantFacade = new VendorExternalMerchantFacade(getConfig('vendor'), getInterceptors());
